import React, { useEffect } from "react";
import { useLocation  } from "react-router-dom";
//actions
import {
  changeLayout,
  changeTopbarTheme,
  changeLayoutWidth,
  changelayoutMode,
} from "../../slices/thunks";
import './horizontalLayout.css';

//constants
import { layoutTypes } from "../../constants/layout";
import TopNav from "../Common/TopNav";

//redux
import { useSelector, useDispatch } from "react-redux";

//components
import Header from "./Header";
import Footer from "./Footer";
import { createSelector } from "reselect";

interface LayoutProps {
  children: any;
}

const Layout = (props: LayoutProps) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const selectLayoutProperties = createSelector(
    (state:any) => state.Layout,
    (layout:any) => ({
      layoutMode: layout.layoutMode,
      topbarTheme: layout.topbarTheme,
      layoutWidth: layout.layoutWidth,
      isPreloader: layout.isPreloader,
      layoutType: layout.layoutType,
      preloader: layout.preloader,
    })
  );
  // Inside your component
  const {
    topbarTheme, layoutWidth, layoutMode, layoutType
  } = useSelector(selectLayoutProperties);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  /*
  layout settings
  */
  useEffect(() => {
    dispatch(changeLayout(layoutTypes.HORIZONTAL));
  }, [dispatch]);

  useEffect(() => {
    if (topbarTheme) {
      dispatch(changeTopbarTheme(topbarTheme));
    }
  }, [dispatch, topbarTheme]);

  useEffect(() => {
    if (layoutWidth) {
      dispatch(changeLayoutWidth(layoutWidth));
    }
  }, [dispatch, layoutWidth]);

  useEffect(() => {
    if (layoutMode) {
      dispatch(changelayoutMode(layoutMode, layoutType));
    }
  }, [layoutMode, dispatch]);

  const showTopNav = ["/reports", "/analytics"].includes(location.pathname);
  const hideFooter = location.pathname === "/cortex-chat";

  return (
    <React.Fragment>
      <div id="layout-wrapper">
        <header id="page-topbar">
          <Header />
        </header>
        <div className="main-content">
          {showTopNav && <TopNav />}
          {props.children}
        </div>
        {!hideFooter && <Footer />}
      </div>
    </React.Fragment>
  );
};

export default Layout;
